import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import {
    breakpoint,
    breakpointMax,
} from '../../../../../__styling/style-functions/breakpoint'
import { CardType, PNFontScales } from '../PNArticleCard'
import { PNArticleCardTheme } from '../../PNCard.Theme'
import { colorsPN, metricsPN } from '@news-mono/design-tokens'
import { calcRem } from '../../../../../__styling'

const { text, fill, stroke } = colorsPN

export const StyledFooter = styled.footer(
    (props: {
        'data-card-type'?: CardType
        'data-font-scale'?: PNFontScales
        isTimestamped?: boolean
        expandedGridSetup?: boolean
    }) => {
        const {
            'data-card-type': cardType,
            'data-font-scale': fontScale = 'M',
            isTimestamped = false,
            expandedGridSetup = false,
        } = props

        return {
            marginTop: expandedGridSetup ? 0 : calcRem(metricsPN.spacing['XS']),
            gridColumn: cardType === 'horizontal' ? '1 / 3' : undefined,
            a: {
                '&:first-child': {
                    // Styles for the first child 'a' Topic element
                    ...PNArticleCardTheme?.[fontScale]?.topic,
                    [breakpointMax('xs')]: {
                        ...PNArticleCardTheme?.S?.topic,
                    },
                },
                '&:last-child': {
                    // Styles for the last child 'a' comment element
                    ...PNArticleCardTheme?.[fontScale]?.comment,
                    [breakpointMax('xs')]: {
                        ...PNArticleCardTheme?.S?.comment,
                    },
                },
            },
            time: {
                ...PNArticleCardTheme?.[fontScale]?.time,
                [breakpointMax('xs')]: {
                    ...PNArticleCardTheme?.S?.time,
                },
            },

            ...(isTimestamped && {
                display: 'none',

                [breakpoint('lg')]: {
                    display: 'block',
                },
            }),
        }
    },
)

export const StyledAuthorCommentGroup = styled('div')(() => ({
    display: 'flex',
}))

export const StyledCommentAnchor = styled(WebLink)(
    (props: { isBreakingStyle?: boolean }) => ({
        color: props.isBreakingStyle ? text.inverse : text.primary,
        alignSelf: 'center',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        borderRadius: `${metricsPN.radius['S']}px`,
        span: {
            display: 'flex',
        },
        '&:hover': {
            background: fill.hover.brand,
        },
        '&:focus-visible': {
            outline: 'revert',
        },
        '&:active': {
            color: `${fill.brand.strong}`,
        },
        '&:active svg path': {
            stroke: `${fill.brand.strong}`,
        },
    }),
)

export const StyledAuthor = styled('span')<{
    hasDivider: boolean
    isBreakingStyle?: boolean
}>(({ hasDivider, isBreakingStyle }) => ({
    position: 'relative',
    marginRight: calcRem(metricsPN.spacing['S']),
    color: isBreakingStyle ? text.inverse : text.primary,
    '&::after': hasDivider
        ? {
              position: 'absolute',
              right: calcRem(-metricsPN.spacing['2XS']),
              content: '""',
              display: 'inline-block',
              width: calcRem(1),
              height: calcRem(14),
              backgroundColor: stroke.weak,
              marginLeft: calcRem(0, metricsPN.spacing['2XS']),
              top: '50%',
              transform: 'translateY(-50%)',
          }
        : undefined,
    ...PNArticleCardTheme.XL.comment,
}))
